// Required "I agree to the Terms & Refund Policy" checkbox — used on signup,
// the pricing page checkout and the lesson re-access dialog. Links open in a
// new tab so the form/checkout state isn't lost. Acceptance is recorded
// server-side (signup payload `accepted_terms`, or POST /legal/accept).
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Checkbox } from './ui/checkbox';
import { useTranslation } from '../context/TranslationContext';

import { getApiBaseUrl } from '@/lib/apiBase';
const API_URL = getApiBaseUrl();

export const recordLegalAcceptance = (headers, planType) =>
  axios.post(
    `${API_URL}/legal/accept`,
    { context: 'checkout', plan_type: planType || null },
    { headers }
  );

const LegalAcceptCheckbox = ({ checked, onChange, error = false, purchase = true, testId = 'legal-accept' }) => {
  const { t } = useTranslation();
  return (
    <div className="space-y-1">
      <label
        htmlFor={testId}
        className={`flex items-start gap-2.5 text-xs leading-relaxed text-left cursor-pointer ${error ? 'text-destructive' : 'text-muted-foreground'}`}
      >
        <Checkbox
          id={testId}
          checked={checked}
          onCheckedChange={(v) => onChange(v === true)}
          className={`mt-0.5 ${error ? 'border-destructive' : ''}`}
          data-testid={testId}
        />
        <span>
          {t('legal_accept_prefix', 'I confirm that I have read, understood and agree to the')}{' '}
          <Link to="/terms" target="_blank" rel="noopener noreferrer" className="text-accent underline hover:no-underline">
            {t('legal_terms_link', 'Terms & Conditions')}
          </Link>{' '}
          {t('legal_accept_and', 'and')}{' '}
          <Link to="/refund-policy" target="_blank" rel="noopener noreferrer" className="text-accent underline hover:no-underline">
            {t('legal_refund_link', 'Refund & Cancellation Policy')}
          </Link>
          {purchase
            ? ` ${t('legal_accept_suffix_purchase', 'before purchasing this course.')}`
            : '.'}
        </span>
      </label>
      {error && (
        <p className="text-xs text-destructive pl-6">
          {t('legal_accept_required', 'Please accept the Terms & Conditions and Refund Policy to continue.')}
        </p>
      )}
    </div>
  );
};

export default LegalAcceptCheckbox;
